import styles from './loadingSpinner.module.scss';

export default function LoadingSpinner({message}) {

	return (
		<>
	        <svg className={styles.spinner} viewBox='0 0 200 200' fill='none'>
	            <defs>
	                <linearGradient id='spinner-secondHalf'>
	                    <stop offset='0%' className={styles.color4} />
	                    <stop offset='50%' className={styles.color4} />
	                    <stop offset='100%' className={styles.color3} />
	                </linearGradient>
	                <linearGradient id='spinner-firstHalf'>
	                    <stop offset='0%' className={styles.color1} />
	                    <stop offset='40%' className={styles.color2} />
	                    <stop offset='100%' className={styles.color3} />
	                </linearGradient>
	            </defs>
	            <g strokeWidth='8'>
	                <path stroke='url(#spinner-secondHalf)' d='M 4 100 A 96 96 0 0 1 196 100' />
	                <path stroke='url(#spinner-firstHalf)' d='M 196 100 A 96 96 0 0 1 4 100' />
	
	                <path className={styles.cap} strokeLinecap='round' d='M 4 100 A 96 96 0 0 1 4 98' />
	            </g>
	           <animateTransform
	                from='0 0 0'
	                to='360 0 0'
	                attributeName='transform'
	                type='rotate'
	                keyTimes='0; .25; .5; .75; 1'
	                values='0 0 0;180 0 0;250 0 0;300 0 0;360 0 0'
	                repeatCount='indefinite'
	                dur='1300ms'
	            />
	        </svg>
	        {message && <h3>{message}</h3>}
	    </>
	);

}

